import { CircleCheck } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

type Props = {
  setShowDialog: (data: boolean) => void;
};

export function Shield({ setShowDialog }: Props) {
  return (
    <div className="mx-auto max-w-5xl lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">
      <div className="items-center space-y-4 text-center lg:text-start">
        <p className="font-bold text-3xl tracking-tight">
          Allt du behöver för att minska och radera din digitala exponering
        </p>
        <p className="text-muted-foreground">
          Ett engångspaket som identifierar och begär borttagning av exponerad
          persondata samt ger skydd i 12 månader. Levereras med verifierat,
          signerat raderingsbevis.
        </p>
        <p className="text-xs text-muted-foreground mb-4">
          Liknande tjänster kostar 1 000-2 500 SEK per år. Vårt pris inkluderar
          moms och verifierat bevis.
        </p>
      </div>
      <Card className="shadow-2xl shadow-cyan-200 dark:shadow-cyan-900/30">
        <CardHeader>
          <CardTitle className="text-xl">Echorai Shield</CardTitle>
          <span className="text-muted-foreground">
            Planerat pris vid tidig åtkomst: 299 SEK
          </span>
        </CardHeader>
        <CardContent>
          <ul className="space-y-6">
            <li className="flex gap-3">
              <div className="bg-green-100 dark:bg-green-900/30 rounded-full size-4 flex justify-center items-center shrink-0 mt-0.5">
                <CircleCheck className="text-green-700" size={12} />
              </div>
              <span className="text-muted-foreground text-sm">
                Radering från MrKoll, Ratsit, Hitta, Eniro, Merinfo, bland
                annat..
              </span>
            </li>
            <li className="flex gap-3">
              <div className="bg-green-100 dark:bg-green-900/30 rounded-full size-4 flex justify-center items-center shrink-0 mt-0.5">
                <CircleCheck className="text-green-700" size={12} />
              </div>
              <span className="text-muted-foreground text-sm">
                Åtgärder för att minska synlighet i sökmotorer där det är
                möjligt
              </span>
            </li>
            <li className="flex gap-3">
              <div className="bg-green-100 dark:bg-green-900/30 rounded-full size-4 flex justify-center items-center shrink-0 mt-0.5">
                <CircleCheck className="text-green-700" size={12} />
              </div>
              <span className="text-muted-foreground text-sm">
                Juridiskt bindande raderingsbegäran enligt GDPR
              </span>
            </li>
            <li className="flex gap-3">
              <div className="bg-green-100 dark:bg-green-900/30 rounded-full size-4 flex justify-center items-center shrink-0 mt-0.5">
                <CircleCheck className="text-green-700" size={12} />
              </div>
              <span className="text-muted-foreground text-sm">
                Signerat och tidsstämplat raderingsbevis (PDF)
              </span>
            </li>
            <li className="flex gap-3">
              <div className="bg-green-100 dark:bg-green-900/30 rounded-full size-4 flex justify-center items-center shrink-0 mt-0.5">
                <CircleCheck className="text-green-700" size={12} />
              </div>
              <span className="text-muted-foreground text-sm">
                Uppföljande kontroll och övervakning i 12 månader
              </span>
            </li>
            <li className="flex gap-3">
              <div className="bg-green-100 dark:bg-green-900/30 rounded-full size-4 flex justify-center items-center shrink-0 mt-0.5">
                <CircleCheck className="text-green-700" size={12} />
              </div>
              <span className="text-muted-foreground text-sm">
                E-postuppdateringar och support
              </span>
            </li>
          </ul>

          <Button
            variant="cta"
            size="cta"
            onClick={() => setShowDialog(true)}
            className="w-full mt-6"
          >
            Bli först att testa Echorai
          </Button>
          <p className="text-xs text-muted-foreground text-center mt-3">
            Ingen betalning krävs nu. Du blir kontaktad vid lansering.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
